<template>
  <div class="menu-bar-container"
       :class="{ 'menu-bar-container--collapsed': collapse }">
    <div v-if="!collapse"
         class="nav-logo">
      <div class="nav-logo__mark">
        <img class="nav-logo__img"
             :src="getLogoImage()"
             alt="">
      </div>
      <span class="nav-logo__title">{{ getLogoText() }}</span>
    </div>
    <div class="menu-dual-wrap">
      <!-- 一级：左侧窄条，黑色 -->
      <aside class="rail">
        <div class="rail__scroll">
          <button
            v-for="menu in filteredMenuList"
            :key="menu.menuId"
            type="button"
            class="rail__item"
            :class="{ 'is-active': isRailActive(menu) }"
            @click="selectFirstLevel(menu)">
            <img class="rail__icon" :src="getMenuIconSrc(menu)" alt="">
            <span class="rail__label">{{ menu.menuName }}</span>
          </button>
        </div>
        <div v-if="collapse"
             class="rail__footer"
             @click="personal()">
          <img class="rail__icon"
               src="@/assets/images/boyo.png"
               alt="">
        </div>
      </aside>
      <!-- 子级：白底 -->
      <aside v-show="!collapse"
             class="subpanel">
        <div class="menu-search">
          <el-input
            v-model="searchQuery"
            placeholder="搜索菜单"
            clearable
            size="small"
            prefix-icon="el-icon-search">
          </el-input>
        </div>
        <el-menu v-if="activeFirstMenu"
                 ref="navmenu"
                 class="el-menu-vertical-demo submenu-white"
                 background-color="#0c1524"
                 text-color="#cbd5e1"
                 active-text-color="#38bdf8"
                 :collapse="false"
                 :unique-opened="true"
                 :collapse-transition="false"
                 @open="handleOpen"
                 @close="handleClose"
                 @select="handleselect">
          <template v-for="child of activeFirstChildren">
            <el-submenu v-if="child.item&&child.item.length"
                        :index="''+child.menuId"
                        :key="'sub-'+child.menuId"
                        style="position:relative">
              <template slot="title">
                <span>{{child.menuName}}</span>
              </template>
              <el-menu-item v-for="itemchild of child.item"
                            :key="itemchild.menuId"
                            :index="''+itemchild.menuId"
                            @click="path(itemchild.path,itemchild)"
                            style="text-align:left">
                <template slot="title">
                  <span v-if="itemchild.menuName=='首页'" class="nav-home-label">{{itemchild.menuName}}</span>
                  <span v-else>{{itemchild.menuName}}</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else
                          :key="'leaf-'+child.menuId"
                          :index="''+child.menuId"
                          @click="path(child.path,child)"
                          style="text-align:left">
              <template slot="title">
                <span v-if="child.menuName=='首页'" class="nav-home-label">{{child.menuName}}</span>
                <span v-else>{{child.menuName}}</span>
              </template>
            </el-menu-item>
          </template>
        </el-menu>
      </aside>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/api/config'
export default {
  name: 'NavBar',
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      menuList: state => state.app.menuList,
      logoColor: state => state.app.logoColor,
      navColor: state => state.app.navColor,
      fontColor: state => state.app.fontColor,
      TabList: state => state.tabs.TabList,
      activeTab: state => state.tabs.activeTab,
      keepAlive: state => state.tabs.keepAlive
    }),
    filteredMenuList () {
      return this.filterMenuNodesByKeyword(this.menuList, this.searchQuery.trim())
    },
    activeFirstChildren () {
      if (!this.activeFirstMenu || !this.activeFirstMenu.item) return []
      return this.filterMenuNodesByKeyword(this.activeFirstMenu.item, this.searchQuery.trim())
    }
  },
  data () {
    return {
      username: JSON.parse(localStorage.personal).userName,
      loginName: localStorage.indexName,
      pingImgUrl: config.pingImgUrl,
      loginLogo: localStorage.loginLogo,
      loding: false,
      searchQuery: '',
      logoUpdateTimer: null,
      lastCompanyType: '',
      activeFirstMenu: null
    }
  },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/index/refresh') return
        this.syncActiveFirstFromRoute(to)
        this.$nextTick(() => this.handleRoute(to))
      }
    },
    menuList: {
      handler () {
        this.syncActiveFirstFromRoute(this.$route)
        this.$nextTick(() => this.handleRoute(this.$route))
      },
      deep: true
    },
    collapse (val) {
      if (!val) {
        this.$nextTick(() => {
          if (this.$refs.navmenu) {
            this.$refs.navmenu.initOpenedMenu()
          }
        })
      }
    }
  },
  mounted () {
    this.syncActiveFirstFromRoute(this.$route)
    this.$nextTick(() => {
      this.handleRoute(this.$route)
    })
    console.log(this.activeTab)
    this.startLogoUpdateTimer()
  },
  beforeDestroy () {
    if (this.logoUpdateTimer) {
      clearInterval(this.logoUpdateTimer)
    }
  },
  methods: {
    filterMenuNodesByKeyword (list, keyword) {
      if (!list || !list.length) return []
      if (!keyword) return list
      const kw = keyword.toLowerCase()
      const filterTree = nodes => {
        return nodes
          .map(node => {
            const name = (node.menuName || '').toLowerCase()
            const hasChildren = Array.isArray(node.item) && node.item.length > 0
            const filteredChildren = hasChildren ? filterTree(node.item) : []
            const selfMatch = name.includes(kw)
            if (selfMatch) {
              return hasChildren ? { ...node, item: node.item } : { ...node }
            }
            if (filteredChildren.length) {
              return { ...node, item: filteredChildren }
            }
            return null
          })
          .filter(Boolean)
      }
      return filterTree(list)
    },

    menuContainsMenuId (menu, t) {
      if (String(menu.menuId) === t) return true
      if (!menu.item || !menu.item.length) return false
      for (const child of menu.item) {
        if (this.menuContainsMenuId(child, t)) return true
      }
      return false
    },

    findFirstLevelByMenuIndex (menuList, indexId) {
      if (!menuList || !menuList.length) return null
      if (indexId == null || indexId === '') return menuList[0]
      const t = String(indexId)
      for (const menu of menuList) {
        if (this.menuContainsMenuId(menu, t)) return menu
      }
      return menuList[0]
    },

    syncActiveFirstFromRoute (route) {
      const idx = route.meta && route.meta.index
      const list = this.filteredMenuList && this.filteredMenuList.length ? this.filteredMenuList : this.menuList
      if (!list || !list.length) {
        this.activeFirstMenu = null
        return
      }
      const found = this.findFirstLevelByMenuIndex(list, idx)
      this.activeFirstMenu = found || list[0]
    },

    isRailActive (menu) {
      return this.activeFirstMenu && String(this.activeFirstMenu.menuId) === String(menu.menuId)
    },

    selectFirstLevel (menu) {
      if (!menu.item || !menu.item.length) {
        this.path(menu.path, menu)
        return
      }
      this.activeFirstMenu = menu
      this.$nextTick(() => {
        if (this.$refs.navmenu) {
          this.$refs.navmenu.initOpenedMenu()
        }
      })
    },

    getMenuIconSrc (menu) {
      const n = menu.menuName || ''
      if (n.indexOf('采购') !== -1) return require('@/assets/images/字典2.png')
      if (n.indexOf('评铁') !== -1) return require('@/assets/images/接口日志G.png')
      if (n.indexOf('流程') !== -1) return require('@/assets/images/接口日志B.png')
      if (n.indexOf('方案') !== -1) return require('@/assets/images/员工培训.png')
      if (n.indexOf('门岗') !== -1) return require('@/assets/images/库存管理B.png')
      if (n.indexOf('过磅') !== -1) return require('@/assets/images/操作日志B.png')
      if (n.indexOf('员工') !== -1) return require('@/assets/images/人事管理L.png')
      if (n.indexOf('会员') !== -1) return require('@/assets/images/权限2.png')
      if (n.indexOf('系统') !== -1) return require('@/assets/images/基础档案B.png')
      if (n.indexOf('报表') !== -1) return require('@/assets/images/流水日志B.png')
      if (n.indexOf('日志') !== -1) return require('@/assets/images/微信.png')
      if (n.indexOf('往来单位') !== -1) return require('@/assets/images/用户2.png')
      return require('@/assets/images/档案.png')
    },

    getLogoImage () {
      return require('@/assets/images/boyo.png')
    },

    getLogoText () {
      return '游乐园系统'
    },

    startLogoUpdateTimer () {
      this.logoUpdateTimer = setInterval(() => {
        const currentCompanyType = localStorage.companyType || ''
        if (currentCompanyType !== this.lastCompanyType) {
          this.lastCompanyType = currentCompanyType
          this.$forceUpdate()
        }
      }, 1000)
    },

    path (path, menu) {
      localStorage.menuPath = ''
      if (menu && menu.menuName && menu.menuId) {
        localStorage.menuNameActive = menu.menuName
        localStorage.logMenuName = menu.menuName
        localStorage.logMenuCode = menu.menuId
        localStorage.menuPath = menu.path
      }
      if (localStorage.menuPath && localStorage.menuPath.indexOf('Report/ReportsViewList') !== -1) {
        this.$router.push({ name: menu.menuName, query: { t: Date.now() } })
      } else {
        this.$router.push('/index/' + path)
      }
      if (!path || localStorage.menuPath.indexOf('Report/ReportsViewList') !== -1) {
        this.handleRoute(this.$route)
      }
    },

    handleRoute (route) {
      if (route.path === '/index/refresh') {
        return
      }
      const tab = this.TabList.filter(item => item.name === route.name)
      if (!tab.length) {
        const keepAlive = route.path.slice(route.path.lastIndexOf('/') + 1)
        const item = [{
          name: route.name,
          title: route.name,
          keepAlive: keepAlive.substring(0, 1).toUpperCase() + keepAlive.substring(1)
        }]
        this.$store.commit('updateTabList', this.TabList.concat(item))
      }
      this.$store.commit('updateActiveTab', route.name)
      if (this.$refs.navmenu) {
        this.$refs.navmenu.activeIndex = '' + route.meta.index
        this.$refs.navmenu.initOpenedMenu()
      }
    },

    personal () {
      this.path('personal')
    },

    Out () {
      this.$confirm('即将退出系统，是否继续？', '提示', {
        type: 'warning'
      }).then(() => {
        this.loding = true
        this.$store.commit('loding', true)
        this.$api.login.out({ loginTissueId: localStorage.loginTissueId, username: JSON.parse(localStorage.personal).userName }).then(res => {
          this.loding = false
          this.$store.commit('loding', false)
          if (res.code === 0) {
            const rememberedUsername = localStorage.username || ''
            localStorage.clear()
            if (rememberedUsername) {
              localStorage.username = rememberedUsername
            }
            localStorage.password = ''
            this.$message({ message: res.msg, type: 'success' })
            localStorage.removeItem('token')
            localStorage.removeItem('roleId')
            localStorage.removeItem('userButtonList')
            this.$store.commit('RouterLoad', false)
            this.$router.push('/login')
            this.$store.commit('updateTabList', [])
            this.$store.commit('updateActiveTab', '')
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          localStorage.removeItem('token')
          localStorage.removeItem('roleId')
          this.$router.push('/login')
          this.loding = false
          this.$store.commit('loding', false)
        })
      })
    },

    handleOpen (key, keyPath) {
    },

    handleClose (key, keyPath) {
    },

    handleselect (key, keyPath) {
    }
  }
}
</script>
<style lang="stylus" scoped>
/* 侧栏：深色商务风，弱化霓虹和发光 */
$rail-bg-top = #0c1533
$rail-bg-bottom = #060b1d
$rail-glow = rgba(96, 165, 250, 0.1)
$ds-primary = #0b1430
$ds-secondary = #090f25
$ds-accent = #60a5fa
$ds-accent-soft = rgba(96, 165, 250, 0.14)
$ds-accent-line = #3b82f6
$ds-text = #e2e8f0
$ds-text-secondary = #94a3b8
$ds-border = rgba(148, 163, 184, 0.16)
$ds-hover = rgba(51, 65, 85, 0.55)

.menu-bar-container
  position absolute
  top 0
  bottom 0
  left 0
  width var(--sidebar-width, 260px)
  box-sizing border-box
  display flex
  flex-direction column
  z-index 1001
  border-radius 0
  overflow hidden
  background $ds-primary
  font-family 'DIN Alternate', 'HarmonyOS Sans SC', 'Microsoft YaHei', sans-serif
  -webkit-font-smoothing antialiased
  box-shadow 4px 0 24px rgba(2, 6, 23, 0.45)
  &::before
    content ''
    position absolute
    inset 0
    pointer-events none
    z-index 0
    background:
      radial-gradient(circle at 14% 8%, rgba(96, 165, 250, 0.08) 0%, transparent 34%),
      radial-gradient(circle at 88% 72%, rgba(59, 130, 246, 0.07) 0%, transparent 38%),
      repeating-linear-gradient(0deg, rgba(148, 163, 184, 0.012) 0px, rgba(148, 163, 184, 0.012) 1px, transparent 1px, transparent 6px)

  &--collapsed
    width var(--sidebar-collapsed, 64px)

  &::-webkit-scrollbar
    width: 0
    height: 0
  scrollbar-width: none
  -ms-overflow-style: none

// 侧栏顶行「游乐园系统」，与右侧 HeadBar 第一行同高，不占用顶栏区域
.nav-logo
  flex-shrink 0
  height var(--headbar-height, 50px)
  min-height var(--headbar-height, 50px)
  box-sizing border-box
  display flex
  align-items center
  padding 0 14px
  color rgba(248, 250, 252, 0.96)
  font-size 17px
  font-weight 600
  letter-spacing 0.05em
  background radial-gradient(ellipse 100% 140% at 10% 0%, rgba(96, 165, 250, 0.1) 0%, transparent 52%), radial-gradient(ellipse 85% 100% at 100% 85%, rgba(59, 130, 246, 0.08) 0%, transparent 48%), linear-gradient(168deg, $rail-bg-top 0%, #08112b 52%, $rail-bg-bottom 100%)
  border-bottom 1px solid $ds-border

.nav-logo__mark
  flex-shrink 0
  width 34px
  height 34px
  border-radius 10px
  display flex
  align-items center
  justify-content center
  background rgba(15, 23, 42, 0.55)
  box-shadow inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 4px 16px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(148, 163, 184, 0.16)
  border 1px solid rgba(148, 163, 184, 0.2)

.nav-logo__img
  width 24px
  height 24px
  object-fit contain
  display block

.nav-logo__title
  margin-left 10px
  color rgba(248, 250, 252, 0.98)
  font-weight 700
  text-shadow 0 0 10px rgba(148, 163, 184, 0.25)
  letter-spacing 0.08em
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.menu-dual-wrap
  flex 1
  min-height 0
  display flex
  flex-direction row
  overflow hidden
  position relative
  z-index 1

// 一级：窄条 + 底部冰蓝光晕
.rail
  flex-shrink 0
  width var(--sidebar-rail-width, 64px)
  display flex
  flex-direction column
  position relative
  background:
    radial-gradient(ellipse 130% 90% at 50% 100%, $rail-glow 0%, transparent 58%),
    linear-gradient(168deg, $rail-bg-top 0%, #050d18 52%, $rail-bg-bottom 100%)
  border-right 1px solid $ds-border
  box-shadow inset -1px 0 0 rgba(255, 255, 255, 0.03)

.rail__scroll
  flex 1
  min-height 0
  overflow-y auto
  overflow-x hidden
  scrollbar-width none
  -ms-overflow-style none
  padding 10px 0
  display flex
  flex-direction column
  align-items center
  gap 8px
  &::-webkit-scrollbar
    width 0
    height 0

.rail__item
  position relative
  width 100%
  max-width 56px
  margin 0 auto
  padding 9px 4px
  border none
  border-radius 12px
  background transparent
  cursor pointer
  display flex
  flex-direction column
  align-items center
  gap 5px
  color #fff
  transition background 0.28s ease, transform 0.22s ease, box-shadow 0.28s ease, filter 0.25s ease
  &:hover
    background rgba(51, 65, 85, 0.55)
    transform translateY(-1px)
    &::before
      opacity 1
      transform translateY(-50%) scaleY(1)
    .rail__label
      color #f8fbff
      text-shadow 0 0 7px rgba(147, 197, 253, 0.35)
  &::before
    content ''
    position absolute
    left 0
    top 50%
    transform translateY(-50%) scaleY(0.45)
    transform-origin center
    width 3px
    height 22px
    border-radius 0 5px 5px 0
    opacity 0
    background linear-gradient(180deg, #93c5fd, #60a5fa)
    box-shadow 0 0 8px rgba(96, 165, 250, 0.3)
    transition opacity 0.22s ease, transform 0.22s ease
  &.is-active
    background radial-gradient(120% 80% at 50% 0%, rgba(96, 165, 250, 0.16) 0%, transparent 55%), linear-gradient(155deg, rgba(59, 130, 246, 0.14) 0%, rgba(15, 23, 42, 0.45) 100%)
    box-shadow inset 0 0 0 1px rgba(147, 197, 253, 0.24), inset 0 -1px 0 rgba(59, 130, 246, 0.12), 0 6px 18px rgba(0, 0, 0, 0.36), 0 0 0 1px rgba(96, 165, 250, 0.08)
    transform translateY(-1px)
    &::before
      content ''
      position absolute
      left 0
      top 50%
      transform translateY(-50%)
      width 4px
      height 30px
      border-radius 0 6px 6px 0
      background linear-gradient(180deg, #bfdbfe 0%, #60a5fa 48%, #3b82f6 100%)
      box-shadow 0 0 12px rgba(96, 165, 250, 0.38), 0 0 4px rgba(191, 219, 254, 0.28)
    &::after
      content ''
      position absolute
      inset 2px
      border-radius 10px
      border 1px solid rgba(148, 163, 184, 0.14)
      pointer-events none
    animation railPulse 2.2s ease-in-out infinite

.rail__icon
  width 18px
  height 18px
  object-fit contain
  filter brightness(0) invert(1)
  opacity 0.95
  transition opacity 0.22s ease, filter 0.28s ease, transform 0.22s ease
  .rail__item:hover &
    opacity 1
  .rail__item.is-active &
    opacity 1
    filter brightness(0) invert(1) drop-shadow(0 0 3px rgba(96, 165, 250, 0.45))
    transform scale(1.06)

.rail__label
  font-size 13px
  font-weight 500
  letter-spacing 0.04em
  line-height 1.2
  text-align center
  max-width 100%
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
  word-break break-all
  color rgba(226, 232, 240, 0.92)
  transition color 0.22s ease, font-weight 0.22s ease, text-shadow 0.22s ease
  .rail__item.is-active &
    color #f0f9ff
    font-weight 500
    text-shadow 0 0 8px rgba(148, 163, 184, 0.3)

.rail__footer
  flex-shrink 0
  padding 10px 0 12px
  display flex
  justify-content center
  cursor pointer
  border-top 1px solid rgba(255, 255, 255, 0.12)
  transition background 0.2s ease
  &:hover
    background rgba(255, 255, 255, 0.06)
  .rail__icon
    width 28px
    height 28px
    border-radius 50%
    box-shadow 0 0 0 2px rgba(148, 163, 184, 0.22)

// 子级：深蓝板 + 冷色文字
.subpanel
  flex 1
  min-width 0
  display flex
  flex-direction column
  background linear-gradient(180deg, #0e1b2e 0%, $ds-primary 40%, $ds-secondary 100%)
  overflow hidden
  border-right 1px solid rgba(15, 23, 42, 0.85)

.menu-search
  flex-shrink 0
  padding 12px 12px 10px
  background linear-gradient(180deg, rgba(148, 163, 184, 0.06) 0%, transparent 100%)
  border-bottom 1px solid $ds-border

  >>> .el-input__inner
    background: rgba(15, 23, 42, 0.65) !important
    border: 1px solid rgba(148, 163, 184, 0.22) !important
    color: $ds-text !important
    border-radius: 12px
    font-size: 14px
    height: 36px
    line-height: 36px
    transition: border-color 0.2s ease, box-shadow 0.2s ease
    &:hover
      border-color: rgba(148, 163, 184, 0.34) !important
    &:focus
      border-color: $ds-accent !important
      box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.16), 0 10px 24px rgba(2, 6, 23, 0.35) !important
    &::placeholder
      color: $ds-text-secondary !important
      font-size: 12px

  >>> .el-input__prefix .el-icon-search
    color: $ds-text-secondary !important

.nav-home-label
  font-weight 700
  font-size 1.35rem
  padding-left 36px
  letter-spacing 0.04em
  color $ds-accent
  text-shadow 0 0 8px rgba(96, 165, 250, 0.25)

.submenu-white.el-menu-vertical-demo .el-menu-item.is-active .nav-home-label
  color #f0f9ff
  text-shadow 0 0 10px rgba(96, 165, 250, 0.3)

.submenu-white.el-menu-vertical-demo
  border: none
  flex 1
  min-height 0
  background transparent !important
  font-size 16px
  overflow-y auto
  scrollbar-width none
  -ms-overflow-style none
  &::-webkit-scrollbar
    width 0
    height 0

  .el-submenu__title,
  .el-menu-item
    position relative
    background transparent !important
    color: $ds-text !important
    border-bottom: 1px solid $ds-border
    transition: background 0.28s ease, color 0.28s ease, box-shadow 0.28s ease, transform 0.18s ease
    height: 44px
    line-height: 44px
    font-size 16px
    font-weight 500
    &:hover
      background: $ds-hover !important
      color: #f0f9ff !important
      transform translateX(2px)
      &::after
        opacity 1
        transform translateY(-50%) scaleY(1)
    &::after
      content ''
      position absolute
      left 0
      top 50%
      transform translateY(-50%) scaleY(0.5)
      transform-origin center
      width 3px
      height 20px
      border-radius 0 4px 4px 0
      opacity 0
      background linear-gradient(180deg, #93c5fd, #60a5fa)
      box-shadow 0 0 6px rgba(96, 165, 250, 0.24)
      transition opacity 0.2s ease, transform 0.2s ease
    i
      color: $ds-text-secondary !important
      transition color 0.22s ease

  .el-menu-item.is-active
    background linear-gradient(92deg, rgba(96, 165, 250, 0.16) 0%, rgba(59, 130, 246, 0.06) 42%, transparent 78%) !important
    color: #e0f2fe !important
    border-right: none !important
    font-weight 500
    letter-spacing 0.02em
    box-shadow inset 0 0 0 1px rgba(147, 197, 253, 0.14), inset 8px 0 18px rgba(96, 165, 250, 0.05), 0 3px 12px rgba(0, 0, 0, 0.12)
    text-shadow none
    &::before
      content ''
      position absolute
      left 0
      top 6px
      bottom 6px
      width 4px
      border-radius 0 8px 8px 0
      background linear-gradient(180deg, #bfdbfe 0%, $ds-accent 42%, #3b82f6 100%)
      box-shadow 0 0 8px rgba(96, 165, 250, 0.28), 2px 0 6px rgba(59, 130, 246, 0.18)
    i
      color: $ds-accent !important
    animation menuActiveBreath 2.4s ease-in-out infinite

  .el-submenu .el-menu
    background: rgba(3, 7, 17, 0.45) !important
    .el-menu-item
      background: transparent !important
      color: $ds-text !important
      border-bottom: 1px solid $ds-border
      padding-left: 45px !important
      font-size 15px
      font-weight 500
      &:hover
        background: $ds-hover !important
        color: #f0f9ff !important
      &.is-active
        background linear-gradient(92deg, rgba(96, 165, 250, 0.14) 0%, rgba(59, 130, 246, 0.05) 50%, transparent 85%) !important
        color: #e0f2fe !important
        font-weight 500
        border-right: none !important
        letter-spacing 0.02em
        box-shadow inset 0 0 0 1px rgba(147, 197, 253, 0.12), 0 2px 10px rgba(0, 0, 0, 0.1)
        text-shadow none
        &::before
          content ''
          position absolute
          left 0
          top 7px
          bottom 7px
          width 3px
          border-radius 0 6px 6px 0
          background linear-gradient(180deg, #bfdbfe, #3b82f6)
          box-shadow 0 0 7px rgba(96, 165, 250, 0.24)
    .el-menu-item span
      color: inherit !important

  .el-submenu__title .el-submenu__icon-arrow
    color: $ds-text-secondary !important

  .el-submenu.is-opened
    .el-submenu__title
      color: #dbeafe !important
      background linear-gradient(90deg, rgba(96, 165, 250, 0.1) 0%, transparent 70%) !important
      border-right: none !important
      font-weight 500
      box-shadow inset 0 -1px 0 rgba(96, 165, 250, 0.08)
      &::before
        content ''
        position absolute
        left 0
        top 10px
        bottom 10px
        width 3px
        border-radius 0 6px 6px 0
        background rgba(96, 165, 250, 0.45)
        box-shadow 0 0 6px rgba(96, 165, 250, 0.24)
      i
        color: $ds-accent !important

@media (max-width: 768px)
  .menu-bar-container
    width var(--sidebar-collapsed, 64px) !important
  .menu-bar-container .subpanel
    display none !important
  .menu-bar-container .rail
    width 100%
    border-right none
  .menu-bar-container .nav-logo
    justify-content center
    padding 0
  .menu-bar-container .nav-logo__title
    display none

@keyframes railPulse
  0%
    box-shadow inset 0 0 0 1px rgba(147, 197, 253, 0.2), inset 0 -1px 0 rgba(59, 130, 246, 0.1), 0 6px 18px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(96, 165, 250, 0.06)
  50%
    box-shadow inset 0 0 0 1px rgba(191, 219, 254, 0.3), inset 0 -1px 0 rgba(59, 130, 246, 0.16), 0 8px 22px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(147, 197, 253, 0.16)
  100%
    box-shadow inset 0 0 0 1px rgba(147, 197, 253, 0.2), inset 0 -1px 0 rgba(59, 130, 246, 0.1), 0 6px 18px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(96, 165, 250, 0.06)

@keyframes menuActiveBreath
  0%
    filter brightness(1)
  50%
    filter brightness(1.08)
  100%
    filter brightness(1)
</style>



// WEBPACK FOOTER //
// src/views/NavBar/NavBar.vue